export const DEFAULT_DEBOUNCE_TIME = 700;
export const MINIMUM_DEBOUNCE_TIME = 80;
export const FAST_DEBOUNCE_TIME = 200;

export const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
